import React, { Component, Fragment } from "react";
import { inject, observer } from "mobx-react";
import BasicLayout from "layouts/BasicLayout";
import PageHeaderLayout from "layouts/PageHeaderLayout";
import {
	Card,
	Form,
	Select,
	Button,
	Checkbox,
	Tabs,
	Divider,
	Menu,
	Popover,
	Row,
	Dropdown,
	Icon,
	message,
	Modal
} from "antd";
import GeneralTab from "./components/GeneralTab";
import ImageTab from "./components/ImageTab";
import VideoTab from "./components/VideoTab";
import SitesTab from "./components/SitesTab";
import IndexerTab from "./components/IndexerTab";
import AddEditScheduleDialog from "components/AddEditScheduleDialog";
import co from "co";
// import "antd/dist/antd.css";
import styles from "./index.module.less";
import { getRoutes } from "../../utils/utils";
import { locationPrefix } from "common/general";

const FormItem = Form.Item;
const Option = Select.Option;
const TabPane = Tabs.TabPane;

const tailFormItemLayout = {
	wrapperCol: {
		xs: {
			span: 24,
			offset: 0
		},
		sm: {
			span: 20,
			offset: 4
		}
	}
};

const formItemLayout = {
	labelCol: {
		xs: { span: 24 },
		sm: { span: 3 }
	},
	wrapperCol: {
		xs: { span: 24 },
		sm: { span: 21 }
	}
};

@inject("rootStore")
@observer
class MainTabs extends Component {
	constructor(props) {
		super(props);
		this.state = {
			activeKey: "GeneralTab"
		};
	}

	setActiveKey = activeKey => {
		this.setState({ activeKey });
	};

	handleTabChange = activeKey => {
		this.setState({ activeKey });
	};

	render() {
		const { generalTab, imageTab, videoTab, sitesTab, indexerTab } = this.props;
		return (
			<Tabs
				activeKey={this.state.activeKey}
				ref={tabs => (this.tabs = tabs)}
				onChange={this.handleTabChange}
				animated={false}
			>
				<TabPane tab="General" key="GeneralTab" forceRender={true}>
					{generalTab}
				</TabPane>
				<TabPane tab="Image" key="ImageTab" forceRender={true}>
					{imageTab}
				</TabPane>
				<TabPane tab="Video" key="VideoTab" forceRender={true}>
					{videoTab}
				</TabPane>
				<TabPane tab="Sites" key="SitesTab" forceRender={true}>
					{sitesTab}
				</TabPane>
				<TabPane tab="Indexer" key="IndexerTab" forceRender={true}>
					{indexerTab}
				</TabPane>
			</Tabs>
		);
	}
}

@inject("rootStore")
@observer
class Project extends Component {
	toggleEdit = () => {
		const {
			rootStore: { privateProjectStore }
		} = this.props;
		if (!privateProjectStore.ui.editing) {
			privateProjectStore.startEditingProject();
		} else {
			co(
				function*() {
					let response = yield this.generalTab.validateForm();
					if (response != null) {
						message.error("Please fix the problems below before continue");
						this.mainTabs.setActiveKey("GeneralTab");
						yield this.generalTab.validateForm();
						return;
					}
					response = yield this.imageTab.validateForm();
					if (response != null) {
						this.mainTabs.setActiveKey("ImageTab");
						return;
					}
					response = yield this.videoTab.validateForm();
					if (response != null) {
						this.mainTabs.setActiveKey("VideoTab");
						return;
					}

					response = yield this.indexerTab.validateForm();
					if (response != null) {
						message.error("Please fix the problems below before continue");
						this.mainTabs.setActiveKey("IndexerTab");
						return;
					}

					let sites = this.sitesTab.getRowData();
					let selectedSiteCount = sites.reduce((count, site) => {
						if (site.checked) {
							count++;
						}
						return count;
					}, 0);
	
					if (selectedSiteCount > 0) {							
						privateProjectStore.saveProject(sites);
					} else {
						this.mainTabs.setActiveKey("SitesTab");
						message.error("Please fix all the errors below", 5);
					}							
				}.bind(this)
			);
		}
	};

	cancelEdit = () => {
		const {
			rootStore: { privateProjectStore }
		} = this.props;

		if (privateProjectStore.ui.editing) {
			privateProjectStore.cancelEditingProject();
		}
	};

	hideAddEditScheduleDialog = () => {
		const {
			rootStore: { privateProjectStore }
		} = this.props;
		privateProjectStore.hideAddEditScheduleDialog();
	};

	saveSchedule = payload => {
		const {
			rootStore: { privateProjectStore }
		} = this.props;

		privateProjectStore.saveSchedule(payload);
	};

	deleteSchedule = () => {
		const {
			rootStore: { privateProjectStore }
		} = this.props;

		privateProjectStore.deleteSchedule();
	};

	resetSchedule = () => {
		const {
			rootStore: { privateProjectStore }
		} = this.props;

		privateProjectStore.resetSchedule();
	};

	handleScheduleMenuClick = ({ key }) => {
		if (key == "addEditSchedule") {
			this.showAddEditScheduleDialog();
			return;
		}
		if (key == "deleteSchedule") {
			this.deleteSchedule();
			return;
		}
		if (key == "resetSchedule") {
			this.resetSchedule();
			return;
		}
	};

	showAddEditScheduleDialog = () => {
		const {
			rootStore: { privateProjectStore }
		} = this.props;
		let result = co(
			function*() {
				let response = yield this.generalTab.validateForm();
				if (response != null) {
					message.error("Please fix the problems below before continue");
					this.mainTabs.setActiveKey("GeneralTab");
					yield this.generalTab.validateForm();
					return;
				}
				response = yield this.imageTab.validateForm();
				if (response != null) {
					this.mainTabs.setActiveKey("ImageTab");
					return;
				}

				let sites = this.sitesTab.getRowData();
				let selectedSiteCount = sites.reduce((count, site) => {
					if (site.checked) {
						count++;
					}
					return count;
				}, 0);				

				if (selectedSiteCount > 0) {							
					privateProjectStore.showAddEditScheduleDialog();
				} else {
					this.mainTabs.setActiveKey("SitesTab");
					message.error("Please fix all the errors below", 5);
				}								
			}.bind(this)
		);
	};

	startStopProject = () => {
		const {
			rootStore: { privateProjectStore }
		} = this.props;
		const project = privateProjectStore.project;
		if (
			["NEW", "COMPLETED", "STOPPED", "FAILED"].indexOf(project.status) != -1
		) {
			privateProjectStore.startProject();
			return;
		}
		if (["STARTING", "RUNNING"].indexOf(project.status) != -1) {
			privateProjectStore.stopProject();
			return;
		}
	};

	showLastError = () => {
		const {
			rootStore: { privateProjectStore }
		} = this.props;		
		let lastError = privateProjectStore.project.lastError;		
		if (lastError) {
			var errorObj = JSON.parse(lastError);
			let errorArr = [];
			for (let i = 0; i < errorObj.length; i++) {
				errorArr.push(errorObj[i]);
				errorArr.push(<br/>);
			}
			Modal.error({
				title: "Error",
				content: errorArr,
			})
		}		
	}

	render() {
		const {
			rootStore: { privateProjectStore }
		} = this.props;

		let spinning =
        privateProjectStore.ui.loadingProject == true ||
        privateProjectStore.ui.savingProject == true ||
        privateProjectStore.ui.deletingSchedule == true ||
        privateProjectStore.ui.resetingSchedule == true;

		let addEditScheduleDialog = (
			<AddEditScheduleDialog
				ui={privateProjectStore.ui}
				project={privateProjectStore.project}
				siblings={privateProjectStore.siblings}
				hideDialog={this.hideAddEditScheduleDialog}
				saveSchedule={this.saveSchedule}
				deleteSchedule={this.deleteSchedule}
				resetSchedule={this.resetSchedule}
				isPrivate
			/>
		);

		const scheduleMenu = (
			<Menu onClick={this.handleScheduleMenuClick}>
				<Menu.Item key="addEditSchedule">
					{privateProjectStore.project.schedule ? "Edit Schedule" : "Add Schedule"}
				</Menu.Item>
				{privateProjectStore.project.schedule ? (
					<Menu.Item key="deleteSchedule">Delete Schedule</Menu.Item>
				) : (
					<Fragment />
				)}
				{privateProjectStore.project.schedule ? (
					<Menu.Item key="resetSchedule">Reset Schedule</Menu.Item>
				) : (
					<Fragment />
				)}
			</Menu>
		);

		let disableEditingProject =
			["STARTING", "RUNNING", "STOPPING"].indexOf(
				privateProjectStore.project.status
			) != -1;

		let startStopButtonText =
			["RUNNING"].indexOf(privateProjectStore.project.status) != -1 ? "Stop" : "Start";

		let disableStartStopButton =
        privateProjectStore.ui.editing == true
				? true
				: [].indexOf(privateProjectStore.project.status) != -1
					? true
					: false;

		let startButton = (
			<Button
				type="primary"
				disabled={disableStartStopButton}
				onClick={this.startStopProject}
				loading={
					privateProjectStore.ui.startingProject || privateProjectStore.ui.stoppingProject
				}
			>
				{startStopButtonText}
			</Button>
		);

		if (privateProjectStore.project.status == "SCHEDULED") {
			startButton = (
				<Popover
					placement="bottom"
					content="The project is scheduled, you need to delete the schedule first"
					title="Cannot start the project"
					trigger="click"
				>
					<Button type="primary">{startStopButtonText}</Button>
				</Popover>
			);
		}

		const generalTab = (
			<GeneralTab
				ref={generalTab => {
					if (generalTab != null) {
						this.generalTab = generalTab.wrappedInstance;
					} else {
						this.generalTab = null;
					}
				}}
			/>
		);
		const imageTab = (
			<ImageTab
				ref={imageTab => {
					if (imageTab != null) {
						this.imageTab = imageTab.wrappedInstance;
					} else {
						this.imageTab = null;
					}
				}}
			/>
		);
		const videoTab = (
			<VideoTab
				ref={videoTab => {
					if (videoTab != null) {
						this.videoTab = videoTab.wrappedInstance;
					} else {
						this.videoTab = null;
					}
				}}
			/>
		);
		const sitesTab = (
			<SitesTab
				ref={sitesTab => {
					if (sitesTab != null) {
						this.sitesTab = sitesTab.wrappedInstance;
					} else {
						this.sitesTab = null;
					}
				}}
			/>
		);

		const indexerTab = (
			<IndexerTab
				ref={indexerTab => {
					if (indexerTab != null) {
						this.indexerTab = indexerTab.wrappedInstance;
					} else {
						this.indexerTab = null;
					}
				}}
			/>
		);

		let target = "_self";

		if (privateProjectStore.ui.editing) {
			target = "_blank";
		}

		const breadcrumbList = [
			{
				title: "Home",
				href: locationPrefix + "/",
				target: target
			},
			{
				title: "Campaigns",
				href: locationPrefix + "/",
				target: target				
			},
			{
				title: "Campaign",
				href: locationPrefix + "/campaign/" + privateProjectStore.campaign.id,
				target: target
			},
			{
				title: "Project"
			}
		];
		
		return (
			<PageHeaderLayout breadcrumbList={breadcrumbList}>
				{addEditScheduleDialog}
				<Card>
					<Row>
						Project Status:
						<span className={styles.status}>{privateProjectStore.project.status}</span>
					</Row>
					{privateProjectStore.project.lastError ? (<Row>
							<Button type="danger" onClick={this.showLastError}>View Error</Button>
						</Row>): ""}
					<Row>
						<Form layout={"inline"}>
							<FormItem>
								<Button
									type="primary"
									onClick={this.toggleEdit}
									loading={privateProjectStore.ui.savingProject}
									disabled={disableEditingProject}
								>
									{privateProjectStore.ui.editing ? "Save" : "Edit"}
								</Button>
							</FormItem>
							<FormItem
								style={{
									display: privateProjectStore.ui.editing ? "inline-block" : "none"
								}}
							>
								<Button type="primary" onClick={this.cancelEdit}>
									Cancel
								</Button>
							</FormItem>
							<FormItem>{startButton}</FormItem>
							<FormItem>
								<Dropdown overlay={scheduleMenu}>
									<Button type="primary">
										Schedule <Icon type="down" />
									</Button>
								</Dropdown>
							</FormItem>
						</Form>
					</Row>
				</Card>
				<Divider />
				<Card>
					<MainTabs
						{...{ generalTab, imageTab, sitesTab, videoTab, sitesTab, indexerTab }}
						ref={mainTabs => {
							if (mainTabs != null) {
								this.mainTabs = mainTabs.wrappedInstance;
							} else {
								this.mainTabs = null;
							}
						}}
					/>
				</Card>
			</PageHeaderLayout>
		);
	}
}

@inject("rootStore")
@observer
class ProjectPage extends Component {
	getPageTitle = () => {
		return "RankerX";
	};

	render() {
		const {
			rootStore: { privateProjectStore }
		} = this.props;

		let project = "";
		if (!privateProjectStore.ui.loadingProject) {
			project = <Project />;
		}
		return <Fragment>{project}</Fragment>;
	}
}

export default ProjectPage;
